/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment settings constants
 *
 * @author Satyaki Bose
 * @file assignmentSettingsConstants.js
 */

export const GRADEBOOK_DISPLAY_MODE = {
  RAW_SCORE: 'RAW_SCORE',
  EQUAL_WEIGHTING: 'EQUAL_WEIGHTING'
};

export const LATE_WORK_DEADLINE_TYPE = {
  ONE_WEEK: 'ONE_WEEK',
  TWO_WEEKS: 'TWO_WEEKS',
  COURSE_END: 'COURSE_END',
  CUSTOM: 'CUSTOM'
};

export const ASSIGNMENT_AVAILABILITY = {
  IMMEDIATE: 'IMMEDIATE',
  FOUR_WEEKS_BEFORE: 'FOUR_WEEKS_BEFORE',
  TWO_WEEKS_BEFORE: 'TWO_WEEKS_BEFORE',
  ONE_WEEK_BEFORE: 'ONE_WEEK_BEFORE'
};

export const DEFAULT_EQUAL_WEIGHTING_BASE_VALUE = '100';
export const DEFAULT_DUE_TIME = '23:59';
export const DEFAULT_LATE_WORK_PERCENT = '100';

export const BASE_VALUE_MIN = 1;
export const BASE_VALUE_MAX = 100;
export const LATE_WORK_PERCENT_MIN = 0;
export const LATE_WORK_PERCENT_MAX = 100;

export const EMPTY_ASSIGNMENT_SETTINGS_VALUES = {
  gradebookDisplayMode: GRADEBOOK_DISPLAY_MODE.RAW_SCORE,
  equalWeightingBaseValue: DEFAULT_EQUAL_WEIGHTING_BASE_VALUE,
  defaultDueTime: DEFAULT_DUE_TIME,
  courseTimeZone: '',
  allowLateWork: true,
  lateWorkPercent: DEFAULT_LATE_WORK_PERCENT,
  lateWorkDeadlineType: LATE_WORK_DEADLINE_TYPE.TWO_WEEKS,
  lateWorkCustomDate: '',
  assignmentAvailability: ASSIGNMENT_AVAILABILITY.IMMEDIATE
};

export const defaultConfig = {
  showAlertBanner: true,
  showFormActions: true,
  showCancelButton: true,
  showSaveButton: true,
  showGradebookInfoModal: true,
  disableAllFields: false,
  requireDirtyToSave: false,

  showGradebookSection: true,
  showGradebookSectionTitle: true,
  showGradebookInfoButton: true,
  showRawScoreOption: true,
  showEqualWeightingOption: true,
  showEqualWeightingBaseValue: true,

  showDueDatesSection: true,
  showDueDatesSectionTitle: true,
  showDefaultDueTimeField: true,
  showCourseTimeZoneField: true,

  showLateWorkSection: true,
  showLateWorkSectionTitle: true,
  showAllowLateWorkCheckbox: true,
  showLateWorkRuleRow: true,
  showLateWorkPercentField: true,
  showLateWorkDeadlineField: true,
  showLateWorkCustomDateField: true,

  showAvailabilitySection: true,
  showAvailabilitySectionTitle: true,
  showAvailabilityField: true,

  showSelectCheckIcon: true
};
